/* Gallery and utility controls only. Shopify/Zepto retain purchase ownership. */
(function () {
  'use strict';
  const instances = new WeakMap();
  function initialise(root) {
    if (!root || instances.has(root)) return;
    const controller = new AbortController();
    const signal = controller.signal;
    const photos = Array.from(root.querySelectorAll('[data-mg-t8-photo]'));
    const thumbs = Array.from(root.querySelectorAll('[data-mg-t8-thumb]'));
    const triggers = new WeakMap();
    let openDialog = null;
    function showImage(id) {
      const selected = photos.find(photo => photo.dataset.imageId === String(id));
      if (!selected) return;
      photos.forEach(photo => photo.classList.toggle('hide', photo !== selected));
      thumbs.forEach(thumb => thumb.setAttribute('aria-pressed', String(thumb.dataset.mgT8Thumb === String(id))));
    }
    function showDialog(dialog, trigger) {
      if (!dialog || typeof dialog.showModal !== 'function') return false;
      if (openDialog && openDialog !== dialog) openDialog.close();
      triggers.set(dialog, trigger);
      if (!dialog.open) dialog.showModal();
      openDialog = dialog;
      return true;
    }
    /* Capture only gallery/guide clicks, not product options or cart submission. */
    root.addEventListener('click', event => {
      if (!(event.target instanceof Element)) return;
      const thumb = event.target.closest('[data-mg-t8-thumb]');
      if (thumb) {
        event.preventDefault(); event.stopImmediatePropagation();
        showImage(thumb.dataset.mgT8Thumb); return;
      }
      const guide = event.target.closest('[data-mg-open-guide]');
      if (guide) {
        const dialog = document.getElementById(guide.dataset.mgOpenGuide);
        if (showDialog(dialog, guide)) { event.preventDefault(); event.stopImmediatePropagation(); }
        return;
      }
      const close = event.target.closest('[data-mg-close-guide]');
      if (close) { close.closest('dialog')?.close(); return; }
      const zoom = event.target.closest('[data-mg-t8-zoom]');
      if (zoom) {
        const dialog = root.querySelector('[data-mg-zoom-dialog]');
        const image = zoom.querySelector('img');
        const enlarged = dialog?.querySelector('[data-mg-zoom-image]');
        if (image && enlarged) {
          enlarged.src = image.currentSrc || image.src;
          enlarged.alt = image.alt || '';
          if (showDialog(dialog, zoom)) { event.preventDefault(); event.stopImmediatePropagation(); }
        }
        return;
      }
      const adjust = event.target.closest('[data-mg-quantity-adjust]');
      if (adjust) {
        const input = root.querySelector('[data-mg-quantity]');
        if (!input) return;
        const current = Number.parseInt(input.value, 10) || 1;
        input.value = String(Math.max(1, current + Number(adjust.dataset.mgQuantityAdjust)));
        input.dispatchEvent(new Event('input', {bubbles:true}));
        input.dispatchEvent(new Event('change', {bubbles:true}));
      }
    }, {capture:true, signal});
    root.querySelectorAll('.mg-t8-dialog').forEach(dialog => {
      dialog.addEventListener('close', () => {
        if (openDialog === dialog) openDialog = null;
        const trigger = triggers.get(dialog);
        if (trigger?.isConnected) trigger.focus({preventScroll:true});
      }, {signal});
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      }, {signal});
    });
    /* The vintage theme also switches image on its jQuery variant event. */
    const $ = window.jQuery;
    if ($) $(root).on('variantImageChange.mgTemplate8Layout', event => {
      if (event.variant?.featured_image?.id) showImage(event.variant.featured_image.id);
    });
    const initial = photos.find(photo => !photo.classList.contains('hide')) || photos[0];
    if (initial) showImage(initial.dataset.imageId);
    instances.set(root, {controller, close:() => openDialog?.close()});
  }
  function within(scope) {
    if (scope.matches?.('.mg-template8[data-mg-layout="2"]')) initialise(scope);
    scope.querySelectorAll('.mg-template8[data-mg-layout="2"]').forEach(initialise);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => within(document), {once:true});
  else within(document);
  document.addEventListener('shopify:section:load', event => within(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('.mg-template8[data-mg-layout="2"]').forEach(root => {
      const instance = instances.get(root);
      instance?.close(); instance?.controller.abort();
      if (window.jQuery) window.jQuery(root).off('.mgTemplate8Layout');
      instances.delete(root);
    });
  });
})();
